import React, { useEffect, useRef } from 'react';
import './VideoFeed.css'; // Import the CSS file

function VideoFeed() {
  const videoRef = useRef(null);

  useEffect(() => {
    const fetchVideo = () => {
      videoRef.current.src = 'http://localhost:5000/video_feed';
    };

    fetchVideo();
  }, []);

  return (
    <div className="video-frame">
      <h2>Live Weapon Detection</h2>
      <img ref={videoRef} alt="Video Feed" className="video" />
    </div>
  );
}

export default VideoFeed;
